import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { Badge, IconButton } from '@mui/material';

import { BADGE_MAX } from './notifications.utils.js';
import { NotificationsPopover } from './NotificationsPopover.js';
import { NOTIFICATION_TOUR_ANCHORS } from './notificationTourAnchors.js';
import { useNotificationCounts } from './useNotificationCounts.js';

export function NotificationBell() {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { counts, markAllAsRead, markAsRead } = useNotificationCounts();

  const handleClose = useCallback(() => setAnchorEl(null), []);

  const label = intl.formatMessage({ id: 'NOTIFICATIONS.TITLE', defaultMessage: 'Notifications' });

  return (
    <>
      <IconButton
        aria-label={label}
        id={NOTIFICATION_TOUR_ANCHORS.bell}
        sx={{ color: 'inherit' }}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <Badge badgeContent={counts.unread} color="error" max={BADGE_MAX}>
          <NotificationsNoneOutlinedIcon />
        </Badge>
      </IconButton>
      <NotificationsPopover
        anchorEl={anchorEl}
        counts={counts}
        markAllAsRead={markAllAsRead}
        markAsRead={markAsRead}
        onClose={handleClose}
      />
    </>
  );
}
